<script setup name="Template2">
import { ref, onMounted, onUnmounted, nextTick, inject, watch } from "vue";
import ContainerCom from "./ContainerCom.vue";
import TextCom from "./TextCom.vue";
import { ElMessageBox } from "element-plus";
import api from "../api/index";
import { useI18n } from "vue-i18n";

// 从App.vue中注入内容映射更新函数

const updateContentMap = inject("updatecontentMap", () => {});
const contentMap = inject("contentMap", () => {});
// 为模板组件定义属性
const { t } = useI18n();
const props = defineProps({
  templateId: {
    type: String,
    default: "",
  },
});

const filteredContents = ref([]);
const isLoggedIn = inject("isLoggedIn", false);
// 处理删除事件
const handleDelete = (contentId) => {
  emit("handleDelete", props.templateId);
};
const updateOb = () => {
  // 获取所有需要观察的子容器元素
  const items = document.querySelectorAll(".sub-container-item");
  items.forEach((item) => {
    // 初始设置为不可见状态
    item.classList.add("invisible");
    // 开始观察元素
    observer.observe(item);
  });
};
watch(
  () => contentMap.value,
  (newVal, oldVal) => {
    if (newVal !== oldVal) {
      getData();
    }
  },
);
const getData = async () => {
  try {

    const res = await api.content.getContentsByTemplate(props.templateId);
    if (res.success) {
      // 处理返回的内容数据,过滤标题和背景content
      const set = new Set(
        res.data
          .filter(
            (item) =>
              !item.contentId.includes("-container") &&
              !item.contentId.includes("-title")
          )
          .map((i) => {
            const id = i.contentId.split("-").pop();
            return id;
          })
      );
      
      const arr = Array.from(set).sort((a, b) => {
          const aNum = parseInt(
            contentMap.value[props.templateId + '-subcontainer-' + a].orderNum || 0,
          );
          const bNum = parseInt(
            contentMap.value[props.templateId + '-subcontainer-' + b].orderNum || 0,
          );
          return aNum - bNum;
        });
      filteredContents.value = [...arr];
      nextTick(() => {
        updateOb();
      });
    }
  } catch (error) {
    console.log(error);
  }
};
const handleAdd = () => {
  api.product.addContents(props.templateId).then((res) => {
    if (res.success) {
          updateContentMap();
      getData();
    }
  });
};
const handleDeleteContent = (contentId) => {
  ElMessageBox.confirm(
    t("product.page.deleteConfirm"),
    t("product.page.deleteConfirmTitle"),
    {
      confirmButtonText: t("product.page.confirm"),
      cancelButtonText: t("product.page.cancel"),
      type: "warning",
    }
  )
    .then(() => {
      //调用删除模板接口
      const data = [
        props.templateId + "-subcontainer-" + contentId,
        props.templateId + "-subtext-" + contentId,
        props.templateId + "-subcontainer-sub-" + contentId,
      ];
      api.content.deleteContentsBatch({ ids: data }).then((res) => {
        if (res.success) {
              updateContentMap();
          getData();
        }
      });
    })
    .catch(() => {
      // 用户点击了取消，不执行任何操作
    });
};

// 定义emits
const emit = defineEmits(["edit", "handleDelete"]);

// 存储Intersection Observer实例
let observer = null;

// 监听组件挂载
onMounted(() => {
  getData();
  // 创建Intersection Observer实例
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 当元素可见度达到20%时，添加可见类
          entry.target.classList.add("visible");
          entry.target.classList.remove("invisible");
          // 移除unobserve调用，允许元素每次进入视口都触发动画
        } else {
          // 当元素完全离开视口时，重置为不可见状态，允许再次进入时触发动画
          // 添加防抖机制，只有当元素完全离开视口时才重置
          if (entry.intersectionRatio <= 0) {
            entry.target.classList.add("invisible");
            entry.target.classList.remove("visible");
          }
        }
      });
    },
    {
      // 设置阈值为20%，即元素20%可见时触发
      threshold: 0,
      // 添加一些margin来提前触发，改善用户体验
      rootMargin: "0px 0px 100px 0px",
    }
  );
});

// 监听组件卸载，清理Observer
onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<!-- 添加组件描述注释 -->
<!-- 2号模板组件：包含一个主containercom，内部含有一个textcom作为标题，以及六个containercom，每个小container中包含一个textcom -->

<template>
  <div class="template-container2">
    <ContainerCom
      :contentId="props.templateId + '-container'"
      :showDelete="true"
      @delete="handleDelete"
      :showOrderNum="true"
      @order="emit('order', $event)"
    >
      <!-- 模板内容区域 -->
      <div class="template-content">
        <!-- 标题文本组件 -->
        <div style="display: inline-block">
          <TextCom class="title-com" :contentId="props.templateId + '-title'" />
        </div>
        <!-- 子容器区域 -->
        <div class="sub-containers">
          <!-- 六个子容器，每个包含一个文本组件 -->
          <div
            class="sub-container-item"
            v-for="i in filteredContents"
            :key="i"
          >
            <ContainerCom
              :contentId="props.templateId + '-subcontainer-' + i"
              :showDelete="true"
              :showOrderNum="true"
              @order="emit('contentOrder', $event, props.templateId + '-subcontainer-' + i)"
              @delete="handleDeleteContent(i)"
            >
              <TextCom
                :floatAnimationEnabled="false"
                class="subtext"
                :contentId="props.templateId + '-subtext-' + i"
              />
              <div class="sub-container-sub">
                <ContainerCom
                  :contentId="props.templateId + '-subcontainer-sub-' + i"
                >
                </ContainerCom>
              </div>
            </ContainerCom>
          </div>
          <div
            class="sub-container-item sub-container-add"
            @click="handleAdd"
            v-if="isLoggedIn"
          >
            <el-icon><Plus /></el-icon>
          </div>
        </div>
      </div>
    </ContainerCom>
  </div>
  <!-- 使用ContainerCom作为主容器 -->
</template>

<style scoped>
/* 模板内容区域样式 */
.template-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding: 80px 10vw;
  background-color: rgb(238, 240, 246);
  /* 响应式内边距 */
  @media (max-width: 600px) {
    padding: 15px 15px 40px 15px;
  }
}

/* 标题居中显示样式 */
:deep(.text-content) {
  width: 100%;
  /* 在小屏幕时居中显示 */
  @media (max-width: 600px) {
    text-align: center;
  }
}

/* 标题样式 */
.title-com {
  margin-bottom: 20px;
}

/* 子容器区域样式 - 使用响应式网格布局 */
.sub-containers {
  display: grid;
  gap: 40px;
  width: 100%;
  margin-top: 20px;
  box-sizing: border-box;
}
.sub-container-item {
  background-color: #fff;
  transition: all 2s cubic-bezier(0.22, 1, 0.36, 1);
  /* border: 1px solid #ccc; */
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 0;
}

.sub-container-item.invisible {
  transform: translateY(100px);
  opacity: 0;
}

.sub-container-item.visible {
  transform: translateY(0);
  opacity: 1;
}

.sub-container-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.template-container2 {
  height: auto;
  /* min-height: 700px; */
}
.sub-container-add {
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 1.5rem;
}
/* 超大屏幕：一行3个，自适应宽度 */
@media (min-width: 1601px) {
  .sub-containers {
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    max-width: 1600px;

    .sub-container-item {
      height: 11.0417vw;

      /* min-height: 250px; */
    }
  }
}

/* 大屏幕：一行3个，自适应宽度 */
@media (min-width: 1101px) and (max-width: 1600px) {
  .sub-containers {
    grid-template-columns: repeat(3, 1fr);
    gap: 35px;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
    .sub-container-item {
      height: auto;
      min-height: 190px;
    }
  }
}
/* 中等屏幕：一行2个，自适应宽度 */
@media (min-width: 601px) and (max-width: 1100px) {
  .sub-containers {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    .sub-container-item {
      height: auto;
      min-height: 190px;
    }
  }
  .template-container2 {
    height: auto !important;
    min-height: 700px;
  }
}

/* 小屏幕：一行1个，自适应宽度 */
@media (max-width: 600px) {
  .sub-containers {
    grid-template-columns: 1fr;
    gap: 20px;
    max-width: 100%;
    .sub-container-item {
      height: auto;
      min-height: 180px;
    }
  }
  .template-container2 {
    height: auto !important;
    /* min-height: 1500px; */
  }
}

/* 超小屏幕：一行1个，自适应宽度 */
@media (max-width: 480px) {
  .sub-containers {
    grid-template-columns: 1fr;
    gap: 15px;
    padding: 0 10px;
  }
}

/* 确保子容器样式 */
.sub-containers > * {
  width: 100%;
}
.sub-container-item {
  border-radius: 15px;
  overflow: hidden;
  position: relative;
}
/* 子容器中的ContainerCom背景图片固定在右下角 */
.sub-container-sub {
  position: absolute;
  right: 1.25vw;
  bottom: 1.5625vw;
  height: 64px;
  width: 64px;
  /* 响应式大小 */
  @media (max-width: 480px) {
    height: 48px;
    width: 48px;
    bottom: 15px;
    right: 15px;
  }
}
.sub-container-sub :deep(.hover-mask-container) {
  min-width: 0px !important;
  min-height: 0px !important;
}
.subtext {
  margin: 2.1875vw 0px 1.0417vw 2.7083vw;
  /* 响应式边距 */
  @media (max-width: 768px) {
    margin: 30px 40px;
  }
  @media (max-width: 480px) {
    margin: 20px 20px;
  }
}
/* 设置sub-container-item中的ContainerCom背景图片固定在右下角 */
/* .sub-container-item :deep(.background-img) {
  background-position: right bottom !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  background-size: contain !important;
} */
.sub-containers :deep(.content-area) {
  width: 100%;
  /* min-height: 100px; */
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

/* 确保文本组件样式 */
:deep(.text-component) {
  width: 100%;
}
</style>
